// extracted by mini-css-extract-plugin
module.exports = {"img":"Services_img__2xx63","service":"Services_service__3Zo5z"};